<template>
  <transition name="modal">
    <div class="modal__mask">
      <div class="modal__wrapper">
        <ModalHeader @close="$emit('close')" :title="editTask.inputTitleFirst" />

        <section class="modal__body">
          <div class="modal__container _mb-4">
            <div class="modal__top-row">
              <div class="align-center">
                <img src="@/assets/img/svg/date-icon.svg" alt="" class="modal__icon">
                <div class="row">
                  <p class="modal__date">{{ dateFrom }}</p>
                  <p class="modal__date"><span class="slesh">/</span></p>
                  <p class="modal__date">{{ dateTo }}</p>
                </div>
              </div>
              
              <div class="align-center modal-views">
                <img src="@/assets/img/svg/okko-icon.svg" alt="" class="modal__icon">
                <div class="row">
                  <p class="modal__date">{{ editTask.inputCountView }}</p>
                </div>
              </div>
            </div>

            <section>
              <div class="edit-modal__images edit-modal-images">
                <div class="edit-modal-images__desktop">
                  <div class="download-img">
                    <div class="download-img__before">
                      <i class="el-icon-download btn-download"
                        @click="downloadIMG(editTask.backgroundSrc)">
                      </i> 
                    </div>
                    <img class="preview" :src="editTask.backgroundSrc" alt="">
                  </div>
                </div>

                <div class="edit-modal-images__mobile">
                  <div class="download-img">
                    <div class="download-img__before">
                      <i class="el-icon-download btn-download"
                        @click="downloadIMG(editTask.backgroundSrcMobile)">
                      </i> 
                    </div>
                    <img class="preview" :src="editTask.backgroundSrcMobile" alt="">
                  </div>
                </div>
              </div>
            </section>

            <div class="modal__top-row">
                <div class="align-center">
                  <div class="edit-modal__vendor">{{ getVendorName(editTask.vendorName) }}</div>
                </div>
                <div class="modal__visible">
                  <p>{{ editTask.visibleGroups }}</p>
                </div>
                <div class="align-center">
                  <p class="modal__tag">#{{ getTagName(editTask.tagName) }}</p>
                </div>
                <div class="align-center">
                  <p class="modal__created-by">{{ editTask.createdByName }}</p>
                </div>
            </div>
            <div class="align-center _mt-15 modal-link-container">
              <div class="modal__icon">
                <img src="@/assets/img/svg/link-icon.svg" alt="">
              </div>
              <p><a :href="'//' + editTask.inputButtonLink" class="modal__link_btn">{{ editTask.inputButtonLink }}</a></p>
            </div>

          </div>

          <div class="modal__container _pt-0" 
            v-if="otherIMGList && otherIMGList.length">
            <h2 class="modal__title">Дополнительные изображения</h2>
            
            <el-carousel type="card" :autoplay="false" height="150px">
              <el-carousel-item v-for="img in otherIMGList" :key="img.id">
                <div class="download-img">
                    <div class="download-img__before">
                      <i class="el-icon-download btn-download"
                        @click="downloadIMG(
                          `${urlAPI}${img.file}`
                        )">
                      </i> 
                    </div>
                    <img class="carousel__img" 
                      :src="`${urlAPI}${img.file}`"
                      alt="">
                </div>
                
              </el-carousel-item>
            </el-carousel>
          </div>
        </section>

        <section class="modal__footer">
          <button class="modal__btn" @click="edit = true">Редактировать</button>
        </section>

      </div>

      <AddTask @double="double" v-if="edit" 
        @delete="delete_banner(editTask)" @close="edit = false" 
        name="RU" :lang="lang" mode="edit" :task="editTask" 
        :platform="platform" :exclude="excludes" 
        :forbiddenDates="forbiddenDates"
        :otherIMGList="otherIMGList" />
    </div>
  </transition>
</template>

<script>
import AddTask from '@/components/modals/AddTaskModal.vue'
import ModalHeader from '@/components/modals/components/ModalHeaderEdit.vue'

import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'EditTaskModal',
  props: ['editTask', 'lang', 'platform', 'exclude', 'forbiddenDates'],
  data() {
    return {
      edit: false,
      excludes: {}
    }
  },
  components: {
    AddTask,
    ModalHeader
  },
  computed: {
    ...mapGetters(['getTags', 'getVendors']),
    urlAPI: function() {
      return process.env.VUE_APP_BACKEND_HOST
    },
    dateFrom: function() {
      if (this.editTask.dateSpace) {
        return this.$moment(this.editTask.dateSpace[0]).format('DD.MM.YY');
      } 
    },
    dateTo: function() {
      if (this.editTask.dateSpace) {
        return this.$moment(this.editTask.dateSpace[1]).format('DD.MM.YY');
      }
    },
    isRu: function() {
      if (this.lang.first === 'RU' || this.lang.second === 'RU') return true
    },
    isEn: function() {
      if (this.lang.first === 'EN' || this.lang.second === 'EN') return true
    },
    isKz: function() {
      if (this.lang.first === 'KZ' || this.lang.second === 'KZ') return true
    },
    isUa: function() {
      if (this.lang.first === 'UA' || this.lang.second === 'EN') return true
    },
    otherIMGList: function() {
      let images = [];
      if ( this.editTask && this.editTask.images && this.editTask.images.length ) {
        this.editTask.images.forEach(img => {
          images.push(img)
        })
      };
      return images;
    }
  },
  methods: {
    delete_banner: function(banner) {
      const agreement = confirm("Вы уверены что хотите удалить баннер? Это действите отменить невозможно.");
      if (agreement) {
        this.$store.dispatch('delete_banner', {id: banner.id});
        this.$emit('close');
      }
    },
    double: function() {
        this.$parent.pushDouble(this.forbiddenDates);
        this.$emit('close');
    },
    getTagName(id) {
      for (const tag of this.getTags) {
          if (tag.id === parseInt(id)) {
              return tag.tagName;
          }
      }
    },
    getVendorName(id) {
        for (const vendor of this.getVendors) {
            if (vendor.id === parseInt(id)) {
                return vendor.vendorName;
            }
        }
    },
    downloadIMG(src) {
      axios({
        url: src,
        method: 'GET',
        responseType: 'blob'
      }).then( response => {
        let fileURL  = window.URL.createObjectURL(new Blob([response.data])),
            fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute(
          'download', 
          `img_${this.$moment(new Date()).format('YYYY-MM-DD-HH-mm-ss')}-${src.slice(-6)}`);

        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
  },
  created() {
    Object.assign(this.excludes, this.exclude);
  },
}
</script>

<style lang="scss" scoped>
.modal__title {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 15px;
  color: #56565A;
}
.modal__mask {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(52, 77, 100, 0.7);
  transition: opacity 0.3s ease;
}

.modal__wrapper {
  background-color: #FFFFFF;
  border-radius: 5px;
  transition: all 0.3s ease;
  width: 65%;
  max-width: 777px;
}

.modal__body { background: #FFFFFF; }
.modal__container { padding: 22px 20px; }
.modal__label {
  font-weight: 400;
  font-size: 15.5px;
  line-height: 20px;
  letter-spacing: -.5px;
  margin-bottom: 10px;
  color: #56565A;
}

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal__top-row {
  display: flex;
  justify-content: flex-start;
}

.modal__date {
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
  color: #034580;
}
.modal__icon {
  margin-right: 5px;
}
.modal__tag {
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin-left: 8px;
  color: #008FC5;
}

.edit-modal-images {
  margin: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.edit-modal-images__desktop {
  width: 599px;
}

.edit-modal-images__mobile {
  width: 119px;
}

.edit-modal-images__desktop,
.edit-modal-images__mobile {
  height: 120px;
}

.edit-modal-images__desktop img,
.edit-modal-images__mobile img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.modal__flag:first-child { margin-right: 5px; }
.modal__visible {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 2px 11px;
  width: fit-content;

  border: 1px solid #DADADA;
  box-sizing: border-box;
  border-radius: 999px;

  & > p {
    font-size: 14px;
    line-height: 22px;
    color: #56565A;
  }
}
.modal__link_btn {
  font-size: 14px;
  line-height: 16px;
  color: #034580;
  transition: all .3 ease;

  &:hover { text-decoration: none; }
}

.modal__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;

  border-top: 1px solid #DADADA;
  box-sizing: border-box;
}
.modal__btn {
  padding: 12px 40px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: #FFFFFF;
  border: 0;
  background: #0A467E;
  cursor: pointer;

  &:focus { outline: none; }
}

.modal-link-container {
  padding: 24px;
  background-color: #F2F9FC;
}
.modal__img {
  width: 100%;
  height: 105px;
  margin: 15px 0;

  & > img {
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
  }
}
.slesh {
  display: flex;
  margin: 0 2px;
}

.edit-modal__vendor {
  padding: 2px 11px;
  background: #FF8686;
  border-radius: 999px;
  font-size: 12px;
  color: #fff;
}
.modal__created-by {
  font-size: 14px;
  color: #56565A;
  margin-left: 10px;
}
.modal-views {
  margin-left: auto;
}

.download-img {
  transition: all .5s ease;
  overflow: hidden;
  position: relative;

  & .download-img__before {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background: rgba(0,0,0,.5);
    top: -50px;
    left: 0;
    width: 100%;
    height: 0;
    transition: all .3s ease;
  }
  
  &:hover {
    & .download-img__before {
      height: 100%;
      top: 0;
    }
  }
}
.btn-download {
  font-size: 25px;
  color: white;
  padding: 10px;
  border: 1px solid white;
  border-radius: 50%;
  filter: invert(.2);
  cursor: pointer;
  transition: all .3s ease;

  &:hover {
    filter: invert(0);
  } 
}

.preview { height: 120px; }
.carousel__img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
._pt-0 { padding-top: 0; }
</style>

<style lang="scss">
.el-carousel__arrow {
  height: 90%;
  border-radius: 2px;
  background-color: rgba(31, 45, 61, 0.51) !important;
}
.el-carousel__arrow--right { right: 0; }
.el-carousel__arrow--left  { left: 0; }
</style>
